<template>
  <q-table class="shadow-25 v-list bg-white"
           style="width:90vw; max-width: 100%;"
           :pagination.sync="pagination"
           :loading="isLoading"
           @request="refreshRows"
           :data.sync="results.data"
           :columns="columns"
           :filter="filter"
           :rows-per-page-options="options.rowsPerPageOptions"
           row-key="id">
    <template slot="top-right" slot-scope="props">
      <v-button v-show="!isActiveToolbar('filter')"
                flat round dense no-caps color="primary"
                icon="search"
                dusk="search-icon"
                @click="toggleToolbar('filter')">
        <q-tooltip v-show="!isActiveToolbar('filter')"
                   anchor="top left" self="bottom middle">
          {{ $T('search') }}
        </q-tooltip>
      </v-button>
      <q-input v-if="isActiveToolbar('filter')"
               hide-underline autofocus color="primary"
               v-model="tempFilter"
               :placeholder="$T('search')"
               @input="updateFilter"
               class="bg-search"
               :before="[{icon: 'search', handler () { toggleToolbar('filter') }}]"/>
      <v-button v-if="exportRoute"
                flat round dense no-caps color="primary"
                icon="cloud download"
                dusk="export-icon"
                @click="callExport">
        <q-tooltip anchor="top left" self="bottom middle">
          {{ $T('export') }}
        </q-tooltip>
      </v-button>

    </template>
  </q-table>
</template>

<script>
const PER_PAGE = 10

const PAGINATION_QUANTITIES = [10, 20, 50, 100]

import {
  debounce
} from 'quasar-framework'
import axios from 'axios'

export default {
  name: "TableWithPagination",
  props: {
    slug: String,
    columns: Array,
    exportRoute: String,
    exportParams: Object,
    exportFilename: String
  },
  data () {
    return {
      options: {
        //plural: this.plural,
        isTrash: false,
        //singular: this.singular,
        rowsPerPageOptions: PAGINATION_QUANTITIES,
        resourcePath: `${config.appUrl}/api/v1/${this.slug}`,
      },
      isLoading: false,
      pagination: {
        rowsPerPage: PER_PAGE,
        rowsNumber: 0
      },
      filter: '',
      tempFilter: '',
      results: {
        meta: {
          total: 0,
          total_unfiltered: 0,
          total_in_trash: 0,
        },
        data: [],
      },
      visibleColumns: [],
      activeToolbar: this.$route.query.search ? 'filter' : '',
    }
  },
  mounted () {
    this.refreshRows()
  },
  methods: {
    isActiveToolbar (item) {
      return this.activeToolbar == item
    },
    toggleToolbar (item) {
      this.activeToolbar = this.activeToolbar == item ? null : item
    },
    updateFilter: debounce(function () {
      this.filter = this.tempFilter
    }, 500),
    async refreshRows ({pagination, filter} = {pagination: null, filter: null}) {
      if (!pagination) pagination = this.pagination
      if (!filter) filter = this.filter

      let query = { // ETL from component to API
        page: pagination.page,
        sort_by: pagination.sortBy,
        descending: pagination.descending,
        per_page: pagination.rowsPerPage,
        search: filter
      }

      // QTable does not update the pagination and filter models directly
      this.pagination = pagination
      this.tempFilter = this.filter = filter

      await this.request('get', this.options.resourcePath, {params: query})
          .then((response) => {
            console.log(response)
            // we also set (or update) rowsNumber
            this.pagination.rowsPerPage = parseInt(response.per_page)
            this.pagination.rowsNumber = response.total
            this.pagination.page = response.current_page
            console.log(this.pagination)

            // then we update the rows with the fetched ones
            this.results.meta = {
              'current_page': response.data.per_page,
              'per_page': response.data.per_page,
              'search': '',
              'from': response.data.from,
              'to': response.data.to,
              'total': response.data.total,
              'total_unfiltered': 0,
              'total_in_trash': 0,
              'last_page': response.data.last_page,
            }
            this.results.links = {
              'first': response.data.first_page_url,
              'last': response.data.last_page_url,
              'next': response.data.next_page_url,
              'prev': response.data.prev_page_url,
            }
            this.results.data = response.data


          })
    },
    /**
     * Submit a request.
     *
     * @param {string} requestType
     * @param {string} url
     */
    request (requestType, url, data = {}) {
      this.isLoading = true

      return new Promise((resolve, reject) => {
        axios[requestType](url, data)
            .then(response => {
              this.isLoading = false

              resolve(response.data);
            })
            .catch(error => {
              console.log(error)

              reject(error.response.data);
            })
      });
    },
    callExport () {
      this.request('post', this.exportRoute)
          .then((response) => {
            let csvContent = "data:text/json;charset=utf-8," + response;
            let encodedUri = encodeURI(csvContent);
            let link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", this.exportFilename + ".csv");
            document.body.appendChild(link); // Required for FF
            link.click();
            link.remove();
          })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/TableWithPagination.vue